document.querySelectorAll('.enable-scroll-js').forEach((item) => {
  if (item.dataset.scrollTargetInitialized === 'true') return;

  item.dataset.scrollTargetInitialized = 'true';
  item.addEventListener('click', (e) => {
    e.preventDefault();

    const targetElement = document.querySelector('.video-banner-section-scroll-js');

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});